// extracted by mini-css-extract-plugin
export default {"main-div":"MainPage_main-div__ODl3m","menu-list":"MainPage_menu-list__10uLS","parts":"MainPage_parts__eBGL1"};